import { useTranslation } from 'react-i18next';

import Dropdown from '__components/Fields/FieldInput/Dropdown';
import { useMemo } from 'react';
import { GenericOption } from '__pages/SmartConnectors/types';
import { FIELD_TYPES } from 'utility/constants';
import { useKeyBoardContext } from '__hooks/keyboardEventHandler/useKeyBoardContext';

type MFASetting = 'disabled' | 'required_on_every_login';

type MultiFactorAuthenticationProps = {
  value: MFASetting;
  onChange: (id: string, value: GenericOption<MFASetting>) => void;
};

const useMultiFactorAuthentication = (value: MFASetting) => {
  const { t } = useTranslation();

  const options = useMemo<GenericOption<MFASetting>[]>(
    () => [
      { label: t('Disabled'), value: 'disabled' },
      { label: t('Required'), value: 'required_on_every_login' },
    ],
    [t]
  );

  const mfa_setting = value || options[0].value;

  return { options, mfa_setting };
};

export const MultiFactorAuthentication = ({
  value,
  onChange,
}: MultiFactorAuthenticationProps) => {
  const { t } = useTranslation();
  const { getKeyListenersProps } = useKeyBoardContext();
  const { options, mfa_setting } = useMultiFactorAuthentication(value);

  return (
    <Dropdown
      className="spaced-input"
      label={t('Multi-Factor Authentication (MFA)')}
      value={mfa_setting}
      options={options}
      onChange={(value: GenericOption<MFASetting>) => {
        onChange('mfa_setting', value);
      }}
      field={{
        fieldType: FIELD_TYPES.Dropdown,
        options: options,
      }}
      placeholder={t('Select Multi-Factor Authentication')}
      {...getKeyListenersProps('mfa-setting')}
      menuLeftButton={null}
      menuRightButton={null}
    />
  );
};
